import React, { useEffect, useState } from 'react';
import NavBar from '../../components/NavBar';
import { Link, useNavigate } from 'react-router-dom';
import './Knowledge.css'; // Import CSS
import { db, collection, getDocs } from '../../firebaseConfiguration';
import Masonry from 'react-masonry-css'
import Footer from '../../components/Footer';

const Knowledge = () => {
    const [posts, setPosts] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getPosts();
    }, [navigate]);

    const getPosts = async () => {
        try {
            const querySnapshot = await getDocs(collection(db, "posts"));
            const postsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            setPosts(postsData);
            return postsData;
        } catch (error) {
            console.error('Error getting posts:', error);
        } finally {
            console.log('Done getting posts');
            setLoading(false);
        }
    };

    const breakpointColumnsObj = {
        default: 5,
        1100: 4,
        700: 3,
        500: 2
    };

    return (
        <div className='bg-white'>
            <NavBar />

            <div className="container text-center py-3">
                <h1>An Classical - Kiến thức Âm nhạc</h1>
                <p>
                    Chào mừng bạn đến với chuyên mục <strong>kiến thức âm nhạc</strong> tại <strong>An Classical</strong>.
                    Tại đây, bạn sẽ tìm thấy những bài viết chia sẻ về các tác phẩm âm nhạc vĩ đại,
                    câu chuyện của các nhà soạn nhạc nổi tiếng và những kiến thức thú vị về nghệ thuật.
                </p>
            </div>

            <div className="container">
                {loading ? (
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column"
                    >
                        {Array.from({ length: 10 }).map((_, index) => (
                            <div key={index} className="card-item skeleton">
                                <div className="skeleton-img"></div>
                                <div className="skeleton-text"></div>
                                <div className="skeleton-text"></div>
                                <div className="skeleton-button"></div>
                            </div>
                        ))}
                    </Masonry>
                ) : (
                    <Masonry
                        breakpointCols={breakpointColumnsObj}
                        className="my-masonry-grid"
                        columnClassName="my-masonry-grid_column">

                        {posts.map(post => (
                            <div key={post.id} className="card-item position-relative">
                                <img
                                    src={post?.avatar || ''}
                                    alt={post?.title || ''}
                                    className="img-fluid"
                                    onError={(e) => {
                                        e.target.style.height = '200px';
                                        e.target.style.objectFit = 'cover';
                                    }}
                                />

                                <div className="card-overlay d-flex flex-column justify-content-center align-items-center p-3">
                                    <h5 className="text-white">{post?.title || ''}</h5>
                                    <p className="text-white">{post?.subtitle || ''}</p>
                                    <Link
                                        to={{
                                            pathname: `/post-detail/${post.id}`,  // Dùng đường dẫn động
                                            state: { post }  // Truyền state với dữ liệu bài viết
                                        }}
                                        className="btn btn-light btn-custom"
                                    >
                                        Xem chi tiết
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </Masonry>
                )}
            </div>

            <Footer />
        </div>
    )
}

export default Knowledge